<div class="container-content feed-page">
    <div class="feed-layout">
        <!-- Left column: filters with counts and shortcuts -->
        <aside class="feed-aside feed-aside-left">
            <div class="feed-widget">
                <span class="feed-widget-title">Filtros</span>
                <button type="button" *ngFor="let chip of chips" class="feed-widget-row feed-filter" [class.active]="chip.selected"
                    (click)="selectFilter(chip)">
                    <span>{{ chip.label }}</span>
                    <span class="feed-filter-count">{{ countFor(chip) }}</span>
                </button>
            </div>

            <div class="feed-widget" *ngIf="shortcuts.length > 0">
                <span class="feed-widget-title">Atalhos</span>
                <a *ngFor="let shortcut of shortcuts" class="feed-widget-row" [routerLink]="shortcut.route">
                    <mat-icon fontSet="material-icons-outlined">{{ shortcut.icon }}</mat-icon>
                    <span>{{ shortcut.title }}</span>
                </a>
            </div>
        </aside>

        <!-- Center column: search, new post and the feed itself -->
        <main class="feed-main">
            <div class="feed-toolbar">
                <div class="actions-bar">
                    <mat-form-field class="feed-search" appearance="fill">
                        <mat-icon matPrefix>search</mat-icon>
                        <input #searchInput matInput autocomplete="off" (keyup)="applyFilter($event.target.value)"
                            placeholder="Pesquisar publicações">
                    </mat-form-field>
                    <button mat-flat-button color="primary" *ngIf="allowPostManagement" [matMenuTriggerFor]="postOptionsMenu">
                        <mat-icon>add</mat-icon> Criar
                    </button>
                    <mat-menu #postOptionsMenu="matMenu" xPosition="before">
                        <button mat-menu-item (click)="addPost()">
                            <mat-icon>article</mat-icon>
                            <span>Publicação</span>
                        </button>
                        <button mat-menu-item (click)="addPoll()">
                            <mat-icon>poll</mat-icon>
                            <span>Enquete</span>
                        </button>
                        <button mat-menu-item (click)="addEvent()">
                            <mat-icon>event</mat-icon>
                            <span>Evento</span>
                        </button>
                    </mat-menu>
                </div>
                <!-- Shown only while the left column is hidden -->
                <mat-chip-list class="feed-filters" aria-label="Filtros">
                    <mat-chip (click)="selectFilter(chip); " *ngFor="let chip of chips" [selected]="chip.selected">
                        {{ chip.label }}
                    </mat-chip>
                </mat-chip-list>
            </div>

            <div class="feed">
                <ng-container *ngIf="(loading$ | async) && posts.data.length == 0; else feedItems">
                    <mat-card class="feed-card feed-card-skeleton" *ngFor="let width of skeletonWidths" aria-busy="true"
                        aria-label="Carregando">
                        <div class="feed-card-header">
                            <span class="feed-card-icon"></span>
                            <div class="feed-card-heading">
                                <span class="skeleton" [style.width.%]="width"></span>
                                <span class="skeleton" style="width: 30%"></span>
                            </div>
                        </div>
                        <div>
                            <span class="skeleton"></span>
                            <span class="skeleton" style="width: 85%"></span>
                            <span class="skeleton" style="width: 60%"></span>
                        </div>
                    </mat-card>
                </ng-container>

                <ng-template #feedItems>
                    <ng-container *ngFor="let post of posts.filteredData">
                        <app-event-card [attr.id]="getItemID(post)" [event]="post" [allowEventManagement]="allowPostManagement"
                            (onEditRequest)="editEvent($event)" (onCancelRequest)="deleteEvent($event)"
                            (onViewPresenceListRequest)="viewEventPresenceList($event)" *ngIf="isEvent(post)"></app-event-card>
                        <app-poll-card [attr.id]="getItemID(post)" [poll]="post" [allowEditingAnyPost]="allowEditingAnyPost"
                            [allowPostManagement]="allowPostManagement" (onDeleteRequest)="deletePoll($event)"
                            (onVoteRequest)="voteInPoll($event.poll, $event.option)" (onViewVotesRequest)="viewPollVotes($event)"
                            *ngIf="isPoll(post)"></app-poll-card>
                        <app-post-card [attr.id]="getItemID(post)" [post]="post" [allowEditingAnyPost]="allowEditingAnyPost"
                            [allowPostManagement]="allowPostManagement" (onEditRequest)="editPost($event)"
                            (onDeleteRequest)="deletePost($event)" (onPostRate)="ratePost($event)"
                            (onVisibilityUpdate)="updatePostVisibility($event.post, $event.ev)"
                            *ngIf="isPost(post)"></app-post-card>
                    </ng-container>
                    <app-empty-results *ngIf="posts.filteredData.length <= 0" icon="dynamic_feed"
                        heading="Nenhuma publicação encontrada"></app-empty-results>
                </ng-template>
            </div>
        </main>

        <!-- Right column: upcoming events, open polls and conversations -->
        <aside class="feed-aside feed-aside-right">
            <div class="feed-widget">
                <span class="feed-widget-title">Próximos eventos</span>
                <button type="button" *ngFor="let event of upcomingEvents" class="feed-widget-row" (click)="focusItem(event)">
                    <span class="feed-event-date">
                        <span>{{ event.date | date:'MMM' }}</span>
                        <strong>{{ event.date | date:'dd' }}</strong>
                    </span>
                    <span class="feed-widget-text">
                        <span class="feed-widget-row-title">{{ event.title }}</span>
                        <span class="feed-widget-caption">
                            {{ event.date | date:"HH:mm" }}{{ event.location ? ' · ' + event.location : '' }}
                        </span>
                    </span>
                </button>
                <span class="feed-widget-empty" *ngIf="upcomingEvents.length == 0">Nenhum evento agendado.</span>
            </div>

            <div class="feed-widget">
                <span class="feed-widget-title">Enquetes abertas</span>
                <button type="button" *ngFor="let poll of openPolls" class="feed-widget-row" (click)="focusItem(poll)">
                    <mat-icon fontSet="material-icons-outlined" class="primary">how_to_vote</mat-icon>
                    <span class="feed-widget-text">
                        <span class="feed-widget-row-title">{{ poll.title }}</span>
                        <span class="feed-widget-caption">Até {{ poll.dueDate | date:"dd/MM 'às' HH:mm" }}</span>
                    </span>
                    <span class="feed-widget-pill">Votar</span>
                </button>
                <span class="feed-widget-empty" *ngIf="openPolls.length == 0">Nenhuma enquete aguardando seu voto.</span>
            </div>

            <div class="feed-widget" *ngIf="allowMessagesAccess">
                <span class="feed-widget-title">Conversas</span>
                <button type="button" class="feed-widget-row" (click)="goToMessages()">
                    <span class="feed-widget-icon"><mat-icon fontSet="material-icons-outlined">forum</mat-icon></span>
                    <span class="feed-widget-text">
                        <span class="feed-widget-row-title">{{ unreadChats > 0 ? unreadChats + (unreadChats == 1 ? ' conversa não lida' : ' conversas não lidas') : 'Nenhuma conversa não lida' }}</span>
                        <span class="feed-widget-caption">Abrir mensagens</span>
                    </span>
                    <mat-icon class="feed-widget-arrow">chevron_right</mat-icon>
                </button>
            </div>
        </aside>
    </div>

    <!-- Shown only while the right column is hidden -->
    <button class="mat-fab feed-fab" mat-fab color="primary" [matBadge]="unreadChats" matBadgeColor="accent"
        [matBadgeHidden]="unreadChats <= 0" (click)="goToMessages()" matTooltip="Minhas conversas"
        matTooltipPosition="left" aria-label="Minhas conversas" *ngIf="allowMessagesAccess">
        <mat-icon>forum</mat-icon>
    </button>
</div>
